module.exports = "/_next/static/images/addi-ccfd0af23cf6a910d38ac89710e409c9.png";